import SortTypes from '@/utils/SortTypes';
import IVideoSort from '@/utils/IVideoSort';
import VideoSortByDate from '@/utils/VideoSortByDate';
import VideoSortByDefault from '@/utils/VideoSortByDefault';
import VideoSortByName from '@/utils/VideoSortByName';
import VideoSortByViews from '@/utils/VideoSortByViews';
import Region from '@/utils/Region';

export default class VideoSortFactory {

  public static getVideoSort(key: string, region: Region | undefined, channelName: string | undefined): IVideoSort {
    if(!SortTypes.hasKey(key)) {
      throw new Error(`No sort algorithm exists for type ${key}.`);
    }
    switch(key) {
      
      case 'views': return new VideoSortByViews();
      case 'date': return new VideoSortByDate();
      case 'name': return new VideoSortByName();
      default:
      case 'std': return new VideoSortByDefault(new VideoSortByDate(), region, channelName);
    }
  }
}